import { logger } from '@ab-core/logger';
import { isIOS } from './isShopApp';

export const triggerDownload = (url: string, filename: string): void => {
    if (isIOS()) {
        try {
            const tempLink = document.createElement('a');
            tempLink.href = url;
            tempLink.target = '_blank';
            tempLink.rel = 'noopener noreferrer';
            tempLink.download = filename;

            document.body.appendChild(tempLink);
            tempLink.click();
            logger.info({
                title: `Document Download S1 Temporary link with download attribute succeeded:`,
                infos: { url, filename, download: tempLink }
            });
            document.body.removeChild(tempLink);

            return;
        } catch (error) {
            logger.error({
                title: `Document Download S1 Temporary link with download attribute failed:`,
                error
            });
        }

        try {
            const newWindow = window.open(url, '_blank');
            logger.info({
                title: `Document Download S2 Opening new window succeeded:`,
                infos: { url, filename }
            });

            if (newWindow && !newWindow.closed) {
                return;
            }
        } catch (error) {
            logger.error({
                title: 'Document Download S2 Opening new window failed:',
                error
            });
        }

        try {
            window.location.href = url;
            logger.info({
                title: 'Document Download S3 Last fallback succeeded:',
                infos: { url, filename }
            });
        } catch (error) {
            logger.error({
                title: 'Document Download S3 Last fallback failed:',
                error
            });
        }
    } else {
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = filename;
        document.body.appendChild(anchor);
        anchor.click();
        logger.info({
            title: `Document Download Standard download succeeded:`,
            infos: { url, filename, anchor }
        });
        document.body.removeChild(anchor);
    }
};

export const revokeObjectURL = (url: string, delay = 500): void => {
    setTimeout(() => {
        URL.revokeObjectURL(url);
    }, delay);
};
